import { FC } from "react";
import { FactorSearchFormProps } from "./types";
import { Column, Row } from "../../containers";
import { NumberInput, SelectorInput, TextInput } from "../../inputs";
import { Customer, FactorType } from "../../../types";
import { useGeneralStore, useThemeStore } from "../../../stores";
import { FACTOR_TYPE_LIST } from "../../../constants";
import { AlignItems, JustifyContent } from "../../containers/types";
import { Button } from "../../buttons";

const FactorSearchForm: FC<FactorSearchFormProps> = ({
  customer,
  description,
  totalPrice,
  type,
  setCustomer,
  setDescription,
  setTotalPrice,
  setType,
  props,
  buttons = [],
  className = "",
  onSearch = () => {},
  readOnly = false,
  style = {},
}) => {
  const customers = useGeneralStore((s) => s.customers);
  const theme = useThemeStore((s) => s.theme);

  return (
    <Column
      style={{ width: "100%", ...style }}
      gap={15}
      props={props}
      className={className}
    >
      <Row style={{ width: "100%" }} className="finance-input-row" gap={20}>
        <SelectorInput<Customer>
          items={customers}
          uniqueKey={"fullname"}
          selected={customer}
          setSelected={setCustomer || (() => {})}
          stringField={"fullname"}
          renderStrings={["fullname", "phone"]}
          compareFn={(c, v) =>
            c.fullname.toLowerCase().includes(v.toLowerCase()) ||
            c.phone.includes(v)
          }
          label="نام مشتری"
          readOnly={readOnly}
        />

        <TextInput
          label="بابت"
          value={description}
          setValue={setDescription}
          inputProps={{ readOnly }}
        />

        <NumberInput
          label="مبلغ کل (ریال)"
          value={totalPrice}
          setValue={setTotalPrice || (() => {})}
          inputProps={{ readOnly }}
          price
        />
      </Row>

      <Row
        style={{ width: "100%" }}
        className="finance-input-row"
        gap={20}
        alignItems={AlignItems.End}
      >
        <SelectorInput<FactorType>
          items={FACTOR_TYPE_LIST}
          uniqueKey={"name"}
          selected={type}
          setSelected={setType || (() => {})}
          stringField={"fa"}
          renderStrings={["fa"]}
          compareFn={(ft, v) => ft.fa.toLowerCase().includes(v.toLowerCase())}
          label="نوع فاکتور"
          readOnly={readOnly}
        />

        <Row
          style={{ width: "100%", height: 41 }}
          justifyContent={JustifyContent.End}
          gap={10}
        >
          {buttons.includes("search") ? (
            <Button
              onClick={onSearch}
              background={theme.primary}
              color={theme.textOnprimary}
            >
              جستجو
            </Button>
          ) : (
            <></>
          )}
        </Row>
      </Row>
    </Column>
  );
};

export default FactorSearchForm;
